import { FormStep } from '@common/components/BookingForms';
import { ParsedJourneyParams } from '@store/yourJourney/selectors';
import { some } from '@utils/some';
import { Guest } from 'shared-types/Basket';
import { Rate } from 'shared-types/Common';
import { RoomExtra } from 'shared-types/Room';
import { RoomRateFormStepNames, STICKY_BAR_ID } from '../../FormSteps';
import { ExtrasStepV2 } from './ExtrasStepV2';
import { GuestDetailsStepV2 } from './GuestDetailsStepV2';
import { MultiRoomGuestDetailsStepV2 } from './MultiRoomGuestDetailsStepV2';

type EntityListItem = Rate & { id?: string };

type GetFormStepsV2Params = {
  basketGuests: Guest[];
  journeyParams: ParsedJourneyParams;
  addToBasket: (...args: any[]) => Promise<void>;
  setIsSignInModalOpen: (val: boolean) => void;
  metaEntity: {
    type: 'room' | 'rate';
    id: string;
    title?: string;
    rates?: EntityListItem[];
    rooms?: EntityListItem[];
  };
  entity: { type: 'room' | 'rate'; id: string };
  goToNextStep: () => void;
  totalGuestAmount: number;
  availableExtras: RoomExtra[] | null;
  loggedGuest?: Guest | null;
};

export const getFormStepsV2 = ({
  basketGuests,
  journeyParams,
  addToBasket,
  setIsSignInModalOpen,
  metaEntity,
  entity,
  goToNextStep,
  totalGuestAmount,
  availableExtras,
  loggedGuest,
}: GetFormStepsV2Params) => {
  const entities = metaEntity.rates || metaEntity.rooms;
  const selectedEntity =
    entities?.find(({ rateId }) => String(entity.id) === String(rateId)) ||
    entities?.find(({ id }) => String(entity.id) === String(id));

  const isMultiRoom = some(journeyParams.rooms) && journeyParams.rooms.length > 1;
  const rooms = journeyParams.rooms ?? [];

  const guestsProps = {
    selectedEntity,
    stickyBarId: STICKY_BAR_ID,
    basketGuests,
    datePartyData: journeyParams,
    addToBasket,
    goToNextStep,
    handleSignInModalOpen: () => setIsSignInModalOpen(true),
    metaEntity,
    availableExtras,
    totalGuestAmount,
    loggedGuest,
  };

  const extrasProps = {
    selectedEntity,
    stickyBarId: STICKY_BAR_ID,
    addToBasket,
    goToNextStep,
    metaEntity,
    entity,
    availableExtras,
    isMultiRoom,
    rooms,
  };

  return {
    [RoomRateFormStepNames.GUESTS]: (
      <FormStep isNarrow noGutter key={0}>
        {isMultiRoom ? (
          <MultiRoomGuestDetailsStepV2 {...guestsProps} />
        ) : (
          <GuestDetailsStepV2 {...guestsProps} />
        )}
      </FormStep>
    ),
    [RoomRateFormStepNames.EXTRAS]: (
      <FormStep isNarrow noGutter key={1}>
        <ExtrasStepV2 {...extrasProps} />
      </FormStep>
    ),
  };
};
